export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/identity.js
// module id = 607
// module chunks = 0